import OrderAddressText from '../../../../Component/UI/OrderAddressText';
import { linkedOrderRowLayout, OrderRowLayout } from "../../../../Component/orderRowLayout";
import { sellerGiftSourceOrder } from "../../../../Component/sellerGifts";
import { useOrderGiftItems, OrderGiftGridCells } from "../../../../Component/UI/SellerGiftList";
import { OrderListprops } from "../../../../Component/Interface/Order";
import { CheckBox } from "../../../../Component/style/common_style";
import {
  OrderCell,
  OrderHeaderCell,
  OrderTable,
  OrderTableHeader,
  RenderOrderCells,
} from "../../../../Component/style/orderTable_style2";

// 헤더/바디가 같은 컬럼 순서·너비를 공유해야 정렬이 안 어긋난다 — 이 배열이 유일한 기준(SSOT).
const GRID_COLUMNS = [
  "4rem", // 체크박스
  "8rem", // 주문번호
    "8rem", // 주문상세번호
    "10rem", // 주문일시
  "8rem", // 주문자
  "6rem", // 입금자
  "8rem", // 상품코드
  "minmax(28rem, 3fr)", // 품목명
  "minmax(10rem, 1fr)", // 옵션
  "minmax(8rem, 1fr)", // 단가
  "6rem", // 수량
  "minmax(10rem, 1fr)", // 총 금액
  "10rem", // 취소일시
].join(" ");

const Order_cancel = ({
  list,
  total,
  selectOrder,
  setSelectOrder,
  select_status,
  setSelect_status,
}: OrderListprops) => {
  const giftItems = useOrderGiftItems();
  const setting_check_list = (seq: number) => {
    if (select_status !== "") {
      if (
        !window.confirm("모든 주문 선택이 취소됩니다.\n취소하시겠습니까?")
      ) {
        return;
      }
      if (setSelect_status) setSelect_status("");
      return;
    }

    if (!selectOrder || !setSelectOrder) {
      return;
    }
    const copyArr = selectOrder.includes(seq)
      ? selectOrder.filter((item) => item !== seq)
      : [...selectOrder, seq];
    setSelectOrder(copyArr);
  };

  const all_check = () => {
    if (select_status !== "" && setSelect_status) return setSelect_status("");
    if (!setSelectOrder || !selectOrder) return;

    const allDetailSeqs = list.flatMap((order) =>
      order.order_details.map((detail) => detail.detail_seq)
    );

    if (isChecked_all()) {
      setSelectOrder([]);
    } else {
      setSelectOrder(allDetailSeqs);
    }
  };

  const isChecked_all = () => {
    if (select_status !== "") return true;
    if (!selectOrder || selectOrder.length === 0) return false;
    const allDetailSeqs = list.flatMap((order) =>
      order.order_details.map((detail) => detail.detail_seq)
    );
    return allDetailSeqs.length > 0 && allDetailSeqs.every((seq) => selectOrder.includes(seq));
  };
  const isChecked_item = (detail_seq: number) => {
    if (select_status !== "") return true;
    if (selectOrder?.includes(detail_seq)) return true;
    return false;
  };

  return (
    <>
      <OrderTableHeader $columns={GRID_COLUMNS} $minWidth={124}>
        <OrderHeaderCell>
          <CheckBox
            type={"checkbox"}
            className="red"
            onChange={all_check}
            checked={isChecked_all()}
          />
        </OrderHeaderCell>
        <OrderHeaderCell>주문번호</OrderHeaderCell><OrderHeaderCell>주문상세번호</OrderHeaderCell>
        <OrderHeaderCell>주문일시</OrderHeaderCell>
        <OrderHeaderCell>주문자</OrderHeaderCell>
        <OrderHeaderCell>입금자</OrderHeaderCell>
        <OrderHeaderCell>상품코드</OrderHeaderCell>
        <OrderHeaderCell>품목명</OrderHeaderCell>
        <OrderHeaderCell>옵션</OrderHeaderCell>
        <OrderHeaderCell>단가</OrderHeaderCell>
        <OrderHeaderCell>수량</OrderHeaderCell>
        <OrderHeaderCell>총 금액</OrderHeaderCell>
        <OrderHeaderCell className="last">취소일시</OrderHeaderCell>
      </OrderTableHeader>

      {list.map((data, idx) => {
        const gifts = giftItems.filter(gift => sellerGiftSourceOrder(gift) === data.seq
          && (gift.source_product_seq == null || data.order_details.some(detail => Number(detail.product_seq) === Number(gift.source_product_seq))));
        const layout = linkedOrderRowLayout(data.order_details, gifts);
        const rowHeight = layout.rowCount;

        return (
          <OrderRowLayout.Provider key={data.seq} value={layout}><OrderTable aria-label={`주문 ${data.seq}`}
            key={idx}
            className={idx % 2 === 0 ? "" : "x2"}
            $columns={GRID_COLUMNS}
            $minWidth={124}
            $height={rowHeight}
          >
            <OrderGiftGridCells items={gifts} firstRow={1} columns={{1:'blank',3:'number',4:'date',7:'product',8:'name',9:'option',10:'amount',11:'quantity',12:'amount',13:'cancelDate'}} />

            <RenderOrderCells
              detailData={data.order_details}
              searchkey={"seq_check"}
              renderCell={(detail_seq) => (
                <CheckBox
                  type={"checkbox"}
                  className="red"
                  value={detail_seq}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setting_check_list(Number(e.target.value))
                  }
                  checked={isChecked_item(detail_seq)}
                />
              )}
            />
            <OrderCell>{data.seq}</OrderCell><RenderOrderCells detailData={data.order_details} searchkey="seq_check" renderCell={seq => seq} />
            <RenderOrderCells detailData={data.order_details} searchkey={"주문일시"} />

            <OrderCell><OrderAddressText address={data.order_name + (data.buyer_withdrawn ? " (탈퇴 회원)" : "")} /></OrderCell>
            <OrderCell><OrderAddressText address={data.order_nickname || "-"} /></OrderCell>

            {["상품코드", "품목명", "옵션", "단가", "수량", "총 금액"].map((key) => (
              <RenderOrderCells key={key} detailData={data.order_details} searchkey={key} />
            ))}

            <RenderOrderCells
              detailData={data.order_details}
              searchkey={"상태변경일"}
              className="last"
            />
          </OrderTable></OrderRowLayout.Provider>
        );
      })}
    </>
  );
};

export default Order_cancel;
